import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { MessageText } from '@components/text/MessageText';
import { fonts } from '@theme/fontsCustomer';

export const TriggerExecView = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <ToolbarName>{t('Trigger_Execution.Title')}</ToolbarName>
      <Body>
        <MessageText>{t('Trigger_Execution.No_Results')}</MessageText>
      </Body>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: inherit;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: inherit;
  border: 0px;
  padding: 28px 0 20px;
  position: relative;
`;

const ToolbarName = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 18px;
  ${fonts.Headline7};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
`;
